<template>
  <div class="template-connected" :key="user.id">
    <div id="container">
      <div id="title">
        <h1 v-if="add == false">
          Modification utilisateur : {{ user.lastName }}
          {{ user.firstName }}
        </h1>
        <h1 v-else>Ajout d'un utilisateur</h1>
      </div>
      <div id="content" class="form-horizontal">
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <div class="block-flat">
              <div class="block-content">
                <fieldset>
                  <legend>Utilisateur</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Avatar :</label>
                      </b-col>
                      <b-col
                        lg="2"
                        md="9"
                        sm="12"
                        cols="12"
                        class="avatar-profil"
                      >
                        <div class="container-avatar">
                          <div class="profil">
                            <b-img
                              v-if="user.picture == null"
                              img
                              src="../img/avatar-client.png"
                              alt="user-img"
                            />
                            <b-img-lazy
                              v-else
                              img
                              :key="user.picture"
                              :src="user.picture"
                              class="img-circle"
                              alt="user-img"
                            />
                            <label class="change" v-if="!readOnly">
                              <b-form-file
                                @input="upload(user.id)"
                                style="display: none"
                                v-model="picture"
                                accept="image/jpeg, image/bmp, image/png"
                                hidden
                              ></b-form-file>
                              <font-awesome-icon
                                icon="camera"
                              ></font-awesome-icon>
                            </label>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Nature :</label>
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <b-row class="no-margin">
                          <b-col lg="3" md="3" sm="3" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="titre"
                            >
                              <b-form-select
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.nature"
                                :options="natures"
                              ></b-form-select>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                  <!--<div id="par">-->
                  <div class="form-group" v-if="user.nature == 'Particulier'">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Titre <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <b-row class="no-margin">
                          <b-col lg="2" md="3" sm="3" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="titre"
                            >
                              <b-form-select
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.title"
                                :options="titles"
                              ></b-form-select>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="5" md="9" sm="9" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="nom"
                            >
                              <b-form-input
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.lastName"
                                placeholder="Merci de renseigner le nom"
                              ></b-form-input>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="5" md="12" sm="12" cols="12">
                            <ValidationProvider
                              mode="lazy"
                              v-slot="{ errors }"
                              rules="required"
                              name="prénom"
                            >
                              <b-form-input
                                :disabled="readOnly"
                                :state="errors[0] ? false : null"
                                v-model="user.firstName"
                                placeholder="Merci de renseigner le prénom"
                              ></b-form-input>
                              <div class="error">{{ errors[0] }}</div>
                            </ValidationProvider>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Fonction <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="form-with-label"
                      >
                        <b-form-input
                          :disabled="readOnly"
                          v-model="user.quality"
                          placeholder="Merci de renseigner votre fonction"
                        ></b-form-input>
                      </b-col>
                    </b-row> -->
                  </div>
                  <!--<div id="entreprise">-->
                  <div class="form-group" v-if="user.nature !== 'Particulier'">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Dénomination :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.corporationName"
                          class="form-control send-api"
                          placeholder="Dénomination"
                          maxlength="100"
                        />
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">N° SIRET :</label>
                      </b-col>
                      <b-col lg="4" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.corporationSiret"
                          placeholder="N° SIRET"
                        />
                      </b-col>
                      <b-col
                        lg="2"
                        md="3"
                        sm="12"
                        cols="12"
                        class="marginTop no-padding"
                      >
                        <label class="control-label">Représenté par :</label>
                      </b-col>
                      <b-col
                        lg="10"
                        md="9"
                        sm="12"
                        cols="12"
                        class="no-padding"
                      >
                        <b-row>
                          <b-col lg="2" md="3" sm="3" cols="12">
                            <b-form-select
                              class="send-api"
                              v-model="user.corporationAgentTitle"
                              :options="titles"
                            ></b-form-select>
                          </b-col>
                          <b-col lg="10" md="9" sm="9" cols="12">
                            <b-form-input
                              type="text"
                              v-model="user.corporationAgent"
                              placeholder="Nom du représentant"
                              maxlength="100"
                            ></b-form-input>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Coordonnées</legend>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Numéro :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          type="number"
                          v-model="user.addressNum"
                          placeholder="Numéro"
                        ></b-form-input
                      ></b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Extension :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.addressExt"
                          placeholder="Extension"
                          maxlength="10"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Type de voie :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.addressType"
                          placeholder="Type de voie"
                          maxlength="100"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Nom de voie :</label>
                      </b-col>
                      <b-col lg="10" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.addressName"
                          placeholder="Nom de la voie"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Localité :</label>
                      </b-col>
                      <b-col lg="6" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.addressCity"
                          class="form-control autocomplete ville"
                          placeholder="Localité"
                        ></b-form-input>
                      </b-col>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label">Code postal :</label>
                      </b-col>
                      <b-col lg="2" md="9" sm="12" cols="12">
                        <b-form-input
                          type="text"
                          v-model="user.addressPostalCode"
                          placeholder="Code postal"
                        ></b-form-input
                      ></b-col>
                    </b-row>
                  </div>
                  <div class="form-group">
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label clearfix"
                          >Adresse email <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="10" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="required|email"
                          name="email"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.email"
                            placeholder="Email"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="2" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label clearfix"
                          >Téléphone <span class="red">*</span> :</label
                        >
                      </b-col>
                      <b-col lg="3" md="9" sm="12" cols="12">
                        <ValidationProvider
                          mode="lazy"
                          v-slot="{ errors }"
                          rules="digits:10|required"
                          name="téléphone"
                        >
                          <b-form-input
                            :disabled="readOnly"
                            :state="errors[0] ? false : null"
                            v-model="user.phone"
                          ></b-form-input>
                          <div class="error">{{ errors[0] }}</div>
                        </ValidationProvider>
                      </b-col>
                      <!-- <b-col lg="4" md="3" sm="12" cols="12" class="no-padding">
                        <label class="control-label"
                          >Indicatif pour le pays étranger :</label
                        >
                      </b-col>
                      <b-col lg="3" md="9" sm="12" cols="12">
                        <b-form-input
                          :disabled="readOnly"
                          v-model="user.phoneIndicative"
                          placeholder="Indicatif pays étranger"
                        ></b-form-input>
                      </b-col> -->
                    </b-row>
                  </div>
                </fieldset>
              </div>
            </div>
            <b-row>
              <b-col lg="12" md="12" sm="12" cols="12" class="text-center">
                <b-button
                  @click="cancel()"
                  variant="danger"
                  class="btn-line btn-auto marginBottom-15"
                >
                  <font-awesome-icon icon="times"></font-awesome-icon>
                  Annuler
                </b-button>
                <b-button
                  type="submit"
                  variant="warning"
                  class="btn-auto marginBottom-15"
                  v-if="!readOnly"
                >
                  <font-awesome-icon icon="check"></font-awesome-icon>
                  Valider
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import router from "../router";

export default {
  name: "Account",

  async beforeMount() {
    //edition d'un profil
    if (
      this.$route.params.id &&
      this.$route.params.id != this.userConnected.id
    ) {
      let decrypted = this.$aes.decrypt(this.$route.params.id);
      await this.getUser(decrypted);
      if (!this.userConnected.roles.includes("ROLE_ADMIN")) {
        this.readOnly = true;
      } else {
        this.readOnly = false;
      }
    } else {
      //ajout
      if (this.$route.name == "NewUser") {
        await this.initUser();
        this.add = true;
        this.readOnly = false;
      }
      //edition du profil de l'utilisateur connecté
      else {
        await this.getUserConnected();
        await this.getUser(this.userConnected.id);
        this.add = false;
        this.readOnly = false;
      }
    }
  },
  data: () => ({
    urlapi: window.urlapi,
    publicPath: process.env.BASE_URL,
    picture: null,
    add: false,
    readOnly: false,
  }),
  // titles
  methods: {
    cancel() {
      if (this.$route.params.id) {
        let decrypted = this.$aes.decrypt(this.$route.params.id);
        this.getUser(decrypted);
      } else {
        this.getUser(this.userConnected.id);
      }
      router.push({ name: "Dossiers" });
    },
    save() {
      if (this.add == false) {
        this.updateUser(this.user);
      } else {
        this.addUser(this.user);
      }
    },
    upload(id) {
      let formData = new FormData();
      formData.append("file", this.picture);
      formData.append("userId", id);
      Vue.axios
        .post(window.urlapi + "stduser/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.user.picture = response.data.data;
          Vue.prototype.$awn.success(response.data.message.toString());
        });
    },
    ...Vuex.mapActions("Authentification", ["getUserConnected"]),
    ...Vuex.mapActions("User", [
      "getUser",
      "setUser",
      "updateUser",
      "addUser",
      "initUser",
    ]),
  },

  watch: {},
  computed: {
    user: {
      get() {
        return this.userSelected;
      },
      set(value) {
        this.setUser(value);
      },
    },
    perimetres: function() {
      let tab = [];

      if (
        !this.userConnected.roles.includes("ROLE_GUICHET") &&
        !this.userConnected.roles.includes("ROLE_ADMIN") &&
        this.add == false
      ) {
        tab.push({ value: "department", text: "Département", disabled: true });
        tab.push({ value: "epci", text: "EPCI", disabled: true });
        tab.push({ value: "town", text: "Commune", disabled: true });
      } else {
        tab.push({ value: "department", text: "Département" });
        tab.push({ value: "epci", text: "EPCI" });
        tab.push({ value: "town", text: "Commune" });
      }
      return tab;
    },
    roles: function() {
      let tab = [];

      //DROIT PAR RAPPORT à l'utilisateur connecter
      if (!this.userConnected.roles.includes("ROLE_ADMIN")) {
        if (this.userConnected.roles.includes("ROLE_GESTIONNAIRE")) {
          if (
            this.add == true &&
            !this.user.roles.includes("ROLE_GESTIONNAIRE")
          ) {
            this.user.roles.push("ROLE_GESTIONNAIRE");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
          });
        }
        if (this.userConnected.roles.includes("ROLE_USER")) {
          if (this.add == true && !this.user.roles.includes("ROLE_USER")) {
            this.user.roles.push("ROLE_USER");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
          });
        }
        if (this.userConnected.roles.includes("ROLE_SOUSTRAITANT")) {
          if (
            this.add == true &&
            !this.user.roles.includes("ROLE_SOUSTRAITANT")
          ) {
            this.user.roles.push("ROLE_SOUSTRAITANT");
          }
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: true,
          });
        }
      } else {
        //Droit par rapport au objet selectionné
        if (
          this.user &&
          this.user.roles &&
          this.user.roles.includes("ROLE_USER")
        ) {
          tab.push({
            value: "ROLE_GUICHET",
            text: "Guichet",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: false,
            checked: true,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: false,
          });
        } else if (
          this.user &&
          this.user.roles &&
          this.user.roles.includes("ROLE_SOUSTRAITANT")
        ) {
          tab.push({
            value: "ROLE_GUICHET",
            text: "Guichet",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: false,
            checked: true,
          });
        } else if (
          (this.user.roles && this.user.roles.includes("ROLE_GESTIONNAIRE")) ||
          (this.user.roles && this.user.roles.includes("ROLE_GUICHET"))
        ) {
          tab.push({ value: "ROLE_GUICHET", text: "Guichet", disabled: false });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: false,
          });

          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: true,
            checked: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: true,
            checked: false,
          });
        } else {
          tab.push({ value: "ROLE_GUICHET", text: "Guichet", disabled: false });
          tab.push({
            value: "ROLE_GESTIONNAIRE",
            text: "Gestionnaire de voirie",
            disabled: false,
          });
          tab.push({
            value: "ROLE_USER",
            text: "Opérateur",
            disabled: false,
          });
          tab.push({
            value: "ROLE_SOUSTRAITANT",
            text: "Sous traitant",
            disabled: false,
          });
        }
      }

      return tab;
    },

    ...Vuex.mapGetters("Dossiers", ["dossiers"]),
    ...Vuex.mapGetters("Authentification", ["userConnected", "token"]),
    ...Vuex.mapGetters("User", ["userSelected", "natures", "titles"]),
  },
};
</script>
